<template>
    <div>
        <!-- <p id="create_work">
            <el-button round @click="openDialog">创建班次</el-button>
        </p> -->

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>班次列表</b></p>
            <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                <el-button round type="success" @click="openDialog">创建班次</el-button>
            </p>
        </div>

        <el-table :data="workList" style="width: 100%">
            <el-table-column prop="workName" label="班次名称" min-width="40%">
            </el-table-column>
            <el-table-column prop="workTime" label="时间" min-width="40%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" min-width="20%">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        编辑
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="班次设置" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="form">

                <el-form-item label="班次名称" required :label-width="formLabelWidth">
                    <el-input v-model="form.workName" autocomplete="off" style="width:250px"></el-input>
                </el-form-item>

                <el-form-item label="时间区间" required :label-width="formLabelWidth">
                    <el-time-picker placeholder="开始时间" v-model="form.startTime" value-format="HH:mm"
                        style="width:120px"></el-time-picker>
                    <span> - </span>
                    <el-time-picker placeholder="结束时间" v-model="form.endTime" value-format="HH:mm"
                        style="width:120px"></el-time-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addWork" v-show="saveButtonVisible1">保 存</el-button>
                <el-button type="primary" @click="modifyWork" v-show="saveButtonVisible2">修改</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "WorkSchedule",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            workList: [],
            dialogFormVisible: false,
            saveButtonVisible1: true,
            saveButtonVisible2: false,
            form: {
                id: '',
                workName: '',
                startTime: '',
                endTime: ''
            },
            workTime: '',
            formLabelWidth: '120px'
        }
    },
    methods: {
        handleClick(row) {
            // console.log(row);
            this.form.id = row.id
            this.saveButtonVisible1 = false
            this.saveButtonVisible2 = true
            this.dialogFormVisible = true

            this.form.workName = row.workName
            this.form.startTime = row.startTime
            this.form.endTime = row.endTime
        },
        openDialog() {

            this.form.id = ''
            this.form.workName = ''
            this.form.startTime = ''
            this.form.endTime = ''

            this.dialogFormVisible = true
            this.saveButtonVisible1 = true
            this.saveButtonVisible2 = false
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeWork(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        addWork() {
            this.$axios({
                method: "post",
                url: "/shiro/work/add",
                data: {
                    workName: this.form.workName,
                    startTime: this.form.startTime,
                    endTime: this.form.endTime,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data
                
                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.dialogFormVisible = false
                this.getWork()
            })
        },
        modifyWork() {
            this.$axios({
                method: "put",
                url: "/shiro/work/modify",
                data: {
                    id: this.form.id,
                    workName: this.form.workName,
                    startTime: this.form.startTime,
                    endTime: this.form.endTime,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.dialogFormVisible = false
                this.getWork()
            })
        },
        removeWork(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/work/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getWork()
            })
        },
        getWork() {
            this.$axios({
                method: "post",
                url: "/shiro/work/getAll",
                data: {
                    id: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.workList = result.data.data
                for (let key in this.workList) {
                    this.workList[key].workTime = this.workList[key].startTime + "-" + this.workList[key].endTime
                }
            })
        }
    },
    mounted() {
        this.getWork()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>